var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "070F6C10-DCCE-4D4A-8F49-59FC65D35F50") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.619,12.006 L6.38,12.006 C6.167,12.006 5.995,11.805 5.995,11.558 C5.995,11.311 6.167,11.11 6.38,11.11 L7,11 L7,8 L6.38,7.884 C6.167,7.884 5.995,7.683 5.995,7.436 C5.995,7.189 6.167,6.988 6.38,6.988 L8.894,6.988 C8.971,6.988 8.996,6.956 9.007,6.93 C9.004,6.945 9,6.959 9,7 L9,11 L9.619,11.11 C9.832,11.11 10.005,11.311 10.005,11.558 C10.005,11.805 9.832,12.006 9.619,12.006 L9.619,12.006 Z M7,4 L7.98,4 C7.987,4 7.993,3.996 8,3.996 C8.007,3.996 8.013,4 8.02,4 L9,4 L9,4.94 C9.001,4.962 9.012,4.98 9.012,5.001 C9.012,5.023 9.001,5.041 9,5.062 L9,6 L8.033,6 C8.021,6.001 8.011,6.007 8,6.007 C7.988,6.007 7.978,6.001 7.967,6 L7,6 L7,5.061 C6.998,5.04 6.987,5.023 6.987,5.001 C6.987,4.98 6.998,4.962 7,4.941 L7,4 Z M8,0 C3.581,0 0,3.582 0,8 C0,12.418 3.581,16 8,16 C12.418,16 16,12.418 16,8 C16,3.582 12.418,0 8,0 L8,0 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Web-Desk-Claims_Details",
    transform: "translate(-473.000000, -260.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Info",
    transform: "translate(473.000000, 260.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Info-Icon"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u21B3-\\uD83C\\uDFA8Color",
    mask: "url(#mask-2)",
    fill: "#A8AAB7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.c34bbbd3b706d5a663bb917715a7b00a.svg";
export { ForwardRef as ReactComponent };